import * as React from 'react';
import { COLORS } from "../constants/colors/index";
function InfoOutlineIcon(props) {
  var size = props.size === 'xlarge' ? 64 : 24;
  var iconColors = {
    info: COLORS.notification.info.dark,
    negative: COLORS.notification.negative.dark,
    neutral: COLORS.notification.neutral.dark
  };
  var color = props.color ? iconColors[props.color] : '#F0C';
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z",
    fill: color
  }));
}
export default InfoOutlineIcon;